import { getEkardoApolloClient } from '@netfront/common-library';
import {
  GET_CONTENT_PAGE_BY_URL_QUERY,
  IGetContentPageByUrlQueryGraphQLResponse,
  IGetContentPageByUrlQueryVariables,
  ISearchContentGroupsQueryGraphQLResponse,
  ISearchContentGroupsQueryVariables,
  SEARCH_CONTENT_GROUPS_QUERY,
} from '@netfront/ekardo-content-library';
import { GetStaticPathsResult, NextPage, GetStaticProps } from 'next';
import { ParsedUrlQuery } from 'querystring';

import { ContentPage, ContentPageProps, STATIC_PAGE_REGENERATION_TIME_IN_SECONDS } from '../components';

export interface IStaticPropsContextParams extends ParsedUrlQuery {
  pageUrl: string;
}

const ContentNextPage: NextPage<ContentPageProps> = ({ contentPage }) => {
  return <ContentPage contentPage={contentPage} />;
};

export async function getStaticPaths(): Promise<GetStaticPathsResult> {
  const client = getEkardoApolloClient({
    product: 'EKARDO',
  });

  const {
    data: {
      contentGroup: { searchContentGroups },
    },
  } = await client.query<ISearchContentGroupsQueryGraphQLResponse, ISearchContentGroupsQueryVariables>({
    query: SEARCH_CONTENT_GROUPS_QUERY,
    variables: {
      projectId: String(process.env.REACT_APP_PROJECT_ID),
      type: 'PAGE',
    },
  });

  const contentPages = searchContentGroups.map(({ contentPages: groupContentPages }) => groupContentPages).flat();

  const paths = contentPages.map(({ url: pageUrl }) => ({
    params: {
      pageUrl,
    },
  }));

  return {
    paths,
    fallback: false,
  };
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const { pageUrl } = params as IStaticPropsContextParams;

  const client = getEkardoApolloClient({
    product: 'EKARDO',
  });

  const {
    data: {
      contentPage: { getContentPageByUrl: contentPage },
    },
  } = await client.query<IGetContentPageByUrlQueryGraphQLResponse, IGetContentPageByUrlQueryVariables>({
    query: GET_CONTENT_PAGE_BY_URL_QUERY,
    variables: {
      contentPageUrl: String(pageUrl),
      projectId: String(process.env.REACT_APP_PROJECT_ID),
    },
  });

  return {
    props: {
      contentPage,
    },
    revalidate: STATIC_PAGE_REGENERATION_TIME_IN_SECONDS,
  };
};

// eslint-disable-next-line import/no-default-export
export default ContentNextPage;
